module.exports = __webpack_public_path__ + "static/media/app-store.62f62760.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/app-store.svg
// module id = 1491
// module chunks = 0